import * as Yup from 'yup';

export const CreateAutomaticNoteSchema = () =>
    Yup.object().shape({
        month: Yup.string().required('Month is required.'),
        year: Yup.string().required('Year is required.'),
        voivodeshipId: Yup.number().required('Voivodeship is required.'),
    });

